if (!customElements.get('slideshow-enhanced-component')) {
    class SlideshowEnhancedComponent extends SliderComponent {
        constructor() {
            super();
            this.sliderControlWrapper = this.querySelector('.slider-buttons');
            this.enableSliderLooping = true;

            if (!this.sliderItemsToShow.length) return;

            this.initInfiniteLoop();
            this.initAutoRotate();
        }

        initInfiniteLoop() {
            this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
            if (this.sliderControlButtons.length) {
                this.sliderControlButtons.forEach((link, index) => {
                    link.addEventListener('click', (e) => this.linkToSlide(e, index + 1));
                });
            }

            this.isMoving = false; // Guard against rapid clicks/scrolls

            // Identify original slides
            this.originalSlides = Array.from(this.slider.querySelectorAll('.slideshow__slide'));
            if (this.originalSlides.length < 2) return;

            // Clone first and last slides
            const firstSlide = this.originalSlides[0];
            const lastSlide = this.originalSlides[this.originalSlides.length - 1];

            this.firstClone = firstSlide.cloneNode(true);
            this.lastClone = lastSlide.cloneNode(true);

            // Attribute cleanup
            this.firstClone.removeAttribute('id');
            this.lastClone.removeAttribute('id');
            this.firstClone.setAttribute('aria-hidden', 'true');
            this.lastClone.setAttribute('aria-hidden', 'true');
            this.firstClone.classList.add('slide-clone');
            this.lastClone.classList.add('slide-clone');

            // Eager load images in clones to prevent flicker
            this.firstClone.querySelectorAll('img').forEach(img => {
                img.setAttribute('loading', 'eager');
                img.removeAttribute('loading'); // Some browsers prefer removal
            });
            this.lastClone.querySelectorAll('img').forEach(img => {
                img.setAttribute('loading', 'eager');
                img.removeAttribute('loading');
            });

            // Insert clones
            this.slider.appendChild(this.firstClone);
            this.slider.insertBefore(this.lastClone, firstSlide);

            // Re-query all slides (now includes clones)
            // DOM: [CloneLast, Real1, Real2, ... RealN, CloneFirst]
            this.allSlides = Array.from(this.slider.querySelectorAll('.slideshow__slide'));
            this.totalPages = this.originalSlides.length;

            // Force recalculate offsets
            this.initPages();

            // Start at Real Slide 1 (which is index 1 now)
            // Wait for layout to settle
            requestAnimationFrame(() => {
                this.resetToRealSlide(1, false);

                this.resetToRealSlide(1, false);
            });
        }

        initPages() {
            // Override super to account for clones
            // We just need basic measurements here
            this.sliderItemsToShow = Array.from(this.slider.querySelectorAll('.slideshow__slide'));
            if (this.sliderItemsToShow.length < 2) return;

            this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
            // Don't rely on super's calculation for page count in looping mode
        }

        update() {
            if (this.isReseting) return;

            const scrollLeft = this.slider.scrollLeft;
            const totalWidth = this.slider.scrollWidth;
            const sliderWidth = this.slider.clientWidth;

            // Thresholds for Silent Jump
            if (scrollLeft <= 5) {
                this.isReseting = true;
                this.resetToRealSlide(this.totalPages, false);
                this.isReseting = false;
            }
            else if (scrollLeft >= totalWidth - sliderWidth - 5) {
                this.isReseting = true;
                this.resetToRealSlide(1, false);
                this.isReseting = false;
            }

            this.updateUI();
        }

        updateUI() {
            if (!this.sliderItemOffset) return;

            let rawPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset);
            let realPage = rawPage;

            if (realPage < 1) realPage = this.totalPages;
            else if (realPage > this.totalPages) realPage = 1;

            this.currentPage = realPage;

            if (this.sliderControlButtons) {
                this.sliderControlButtons.forEach((link, index) => {
                    const isActive = (index + 1) === this.currentPage;
                    if (isActive) {
                        link.classList.add('slider-counter__link--active');
                        link.setAttribute('aria-current', 'true');
                        const dot = link.querySelector('.dot');
                        if (dot) dot.style.backgroundColor = '#FFFFFF';
                    } else {
                        link.classList.remove('slider-counter__link--active');
                        link.removeAttribute('aria-current');
                        const dot = link.querySelector('.dot');
                        if (dot) dot.style.backgroundColor = 'rgba(255, 255, 255, 0.5)';
                    }
                });

            }
        }





        resetToRealSlide(pageIndex, animate = false) {
            const scrollPos = pageIndex * this.sliderItemOffset;

            if (animate) {
                this.slider.scrollTo({ left: scrollPos, behavior: 'smooth' });
            } else {
                // Temporarily disable smooth scrolling from CSS
                this.slider.style.setProperty('scroll-behavior', 'auto', 'important');
                this.slider.scrollLeft = scrollPos;
                this.slider.offsetHeight; // Force reflow

                // Restore after paint to ensure no flicker
                requestAnimationFrame(() => {
                    this.slider.style.removeProperty('scroll-behavior');
                });
            }
        }


        initAutoRotate() {
            if (this.slider.getAttribute('data-autoplay') === 'true') {
                this.autoplaySpeed = this.slider.dataset.speed * 1000;
                this.autoPlay = true;
                this.isPaused = false;

                // Add event listeners for pausing/resuming
                this.slider.addEventListener('mouseenter', this.pause.bind(this));
                this.slider.addEventListener('mouseleave', this.play.bind(this));
                this.slider.addEventListener('touchstart', this.pause.bind(this), { passive: true });
                this.slider.addEventListener('touchend', this.play.bind(this));
                this.slider.addEventListener('focusin', this.pause.bind(this));
                this.slider.addEventListener('focusout', this.play.bind(this));

                // Observer for visibility
                const observer = new IntersectionObserver((entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            this.play();
                        } else {
                            this.pause();
                        }
                    });
                });
                observer.observe(this.slider);

                this.play();
            }
        }

        autoRotate() {
            if (this.isPaused || this.isMoving) return;

            // Calculate next page (1-based index)
            let nextPage = this.currentPage + 1;
            if (nextPage > this.totalPages) nextPage = 1;

            this.resetToRealSlide(nextPage, true);
        }

        play() {
            if (!this.autoPlay) return;
            this.isPaused = false;
            clearInterval(this.autoplayInterval);
            this.autoplayInterval = setInterval(this.autoRotate.bind(this), this.autoplaySpeed);
        }

        pause() {
            this.isPaused = true;
            clearInterval(this.autoplayInterval);
        }

        // Override linkToSlide to reset timer
        linkToSlide(event, targetPage) {
            event.preventDefault();
            this.resetToRealSlide(targetPage, true);
            if (this.autoPlay) {
                this.pause();
                this.play();
            }
        }

    }

    customElements.define('slideshow-enhanced-component', SlideshowEnhancedComponent);
}
